import React, { useState, useEffect, useCallback } from 'react';
import styles from "./Declaration.module.scss";
import { storeDeclarationDetails, saveImportExportApplication } from "../../../redux/actions";
import { useDispatch, useSelector} from "react-redux";
import { isSelected, isCompleted, validate, scrollToError } from "../../../utils/Validation";
import { CheckboxSelector, Button, ErrorMsg, RadioSelector } from "@onegovbugs/onegov-react-components";

export const Declaration = ({props, continueButtonHandler, saveApplication}) => {
    
    const dispatch = useDispatch();
    const [agreeDeclaration, setAgreeDeclaration] = useState([]);

    const defaultCheckboxValue = {
      value: 1,
      label: "I agree to all of the above"
    };
    const declarationDetails = useSelector(state => state.declarationDetails);
    
    const checkboxValues = [defaultCheckboxValue];
    const [licenceConditions, setLicenceConditions] = useState(declarationDetails ? declarationDetails.licenceConditions : null);
    const [licenceConditionsComment, setLicenceConditionsComment] = useState(declarationDetails ? declarationDetails.licenceConditionsComment : null);
    const [falseOrMisleadingInfo, setFalseOrMisleadingInfo] = useState(declarationDetails ? declarationDetails.falseOrMisleadingInfo : null);
    const [falseOrMisleadingInfoComment, setFalseOrMisleadingInfoComment] = useState(declarationDetails ? declarationDetails.falseOrMisleadingInfoComment : null);
    const [fraudOrDishonesty, setFraudOrDishonesty] = useState(declarationDetails ? declarationDetails.fraudOrDishonesty : null);
    const [fraudOrDishonestyComment, setFraudOrDishonestyComment] = useState(declarationDetails ? declarationDetails.fraudOrDishonestyComment : null);
    const [technicalCompetencies, setTechnicalCompetencies] = useState(declarationDetails ? declarationDetails.technicalCompetencies : null);

    const radioOptionsYesNo = [
        {
          value: 'yes',
          label: 'Yes'
        },
        {
          value: 'no',
          label: 'No'
        }
      ];

    const [showErrors, setShowErrors] = useState(false);

    useEffect(() => {
        validate(validators, setErrors)
    }, [licenceConditions, falseOrMisleadingInfo, fraudOrDishonesty, technicalCompetencies, licenceConditionsComment, falseOrMisleadingInfoComment, fraudOrDishonestyComment]);

    const storeData = () => {
        dispatch(storeDeclarationDetails({
        licenceConditions, falseOrMisleadingInfo, fraudOrDishonesty,technicalCompetencies, licenceConditionsComment, falseOrMisleadingInfoComment, fraudOrDishonestyComment
        }));
    };

    const validators = [
        {
            fieldName: "licenceConditions",
            fieldValue: licenceConditions,
            isValid: (v) => (isSelected(v))
        },
        {
            fieldName: "falseOrMisleadingInfo",
            fieldValue: falseOrMisleadingInfo,
            isValid: (v) => (isSelected(v))
        },
        {
            fieldName: "fraudOrDishonesty",
            fieldValue: fraudOrDishonesty,
            isValid: (v) => (isSelected(v))
        },
        {
            fieldName: "technicalCompetencies",
            fieldValue: technicalCompetencies,
            isValid: (v) => (isSelected(v))
        },
        {
            fieldName: "licenceConditionsComment",
            fieldValue: licenceConditionsComment,
            isValid: (v) => licenceConditions === 'no' || (licenceConditions === 'yes' && (isCompleted(v)))
        },
        {
            fieldName: "falseOrMisleadingInfoComment",
            fieldValue: falseOrMisleadingInfoComment,
            isValid: (v) => falseOrMisleadingInfo === 'no' || (falseOrMisleadingInfo === 'yes' && (isCompleted(v)))
        },
        {
            fieldName: "fraudOrDishonestyComment",
            fieldValue: fraudOrDishonestyComment,
            isValid: (v) => fraudOrDishonesty === 'no' || (fraudOrDishonesty === 'yes' && (isCompleted(v)))
        }
      ];
    
      const [errors, setErrors] = useState({
        licenceConditions: false,
        licenceConditionsComment: false,
        falseOrMisleadingInfo: false,
        falseOrMisleadingInfoComment: false,
        fraudOrDishonesty: false,
        fraudOrDishonestyComment: false,
        technicalCompetencies: false
      });
    

    return (
        <div className={styles.mainCont}>
            <div className={styles.borderBox}>
            <div className={"row"}>
                <div className={"col-12"}>
                    <div className={styles.content}>
                        <p>
                            For the purposes of the following questions, ‘the applicant and associates’ include the persons nominated to be authorised under this licence, any partner or 
                            other associate to these persons including relatives and friends, and any companies to which these persons have been a director or associated in the management 
                            of a corporation.                    
                        </p>  
                        <h2 className={styles.title}>Has the applicant and/or associates:</h2>
                    </div>                  
                </div>
            </div>
            <div className={'row'}>
                <div className={'col-12'}>
                    <p className={styles.radioOptionsHeading}>
                        contravened any licence conditions, authority or law concerning the protection, 
                        conservation or management of animals or ecological communities?
                    </p>
                    <RadioSelector 
                        options={radioOptionsYesNo}
                        onSelectionChange={(selectedValue) => {
                            setLicenceConditions(selectedValue);
                        }}
                        initialValue={licenceConditions}
                    />
                    {licenceConditions && licenceConditions === 'yes' ?
                    <>
                        <label htmlFor={"setLicenceConditionsComment"}>If your answer is Yes, provide full details below. </label>
                        <textarea maxLength={1000}
                        value={licenceConditionsComment}
                        onChange={obj => {
                            setLicenceConditionsComment(obj.target.value);
                        }}
                        rows={5}
                        cols={5}
                        />
                        <span className={styles.labelMaxChar}>
                            You have {licenceConditionsComment ? 1000 - licenceConditionsComment.length : 1000} characters left.
                        </span>
                    </> : null}
                </div>

                {licenceConditions == null && errors.licenceConditions && showErrors ? (
                    <div className={`col-12 ${styles.errorContainer}`}>
                        <ErrorMsg className={"ErrorMsg_error"}
                            type={"error"}
                            description={"Please make a selection."}
                        />
                    </div>
                ) : null}

                {licenceConditions && errors.licenceConditionsComment && showErrors ? (
                        <div className={`col-12 ${styles.errorContainer}`}>
                        <ErrorMsg className={"ErrorMsg_error"}
                            type={"error"}
                            description={"Further details is required."}
                        />
                        </div>
                    ) : null}
            </div>
            <div className={'row'}>
                <div className={'col-12'}>
                    <p className={styles.radioOptionsHeading}>
                        provided false or misleading information in connection with a matter under the Biodiversity Conservation Act 2016?
                    </p>
                    <RadioSelector className={styles.radioOptions}
                        options={radioOptionsYesNo}
                        onSelectionChange={(selectedValue) => {
                            setFalseOrMisleadingInfo(selectedValue);
                        }}
                        initialValue={falseOrMisleadingInfo}
                    />
                    {falseOrMisleadingInfo && falseOrMisleadingInfo === 'yes' ?
                    <>
                        <label htmlFor={"setFalseOrMisleadingInfoComment"}>If your answer is Yes, provide full details below. </label>
                        <textarea maxLength={1000}
                        value={falseOrMisleadingInfoComment}
                        onChange={obj => {
                            setFalseOrMisleadingInfoComment(obj.target.value);
                        }}
                        rows={5}
                        cols={5}
                        />
                        <span className={styles.labelMaxChar}>
                            You have {falseOrMisleadingInfoComment ? 1000 - falseOrMisleadingInfoComment.length : 1000} characters left.
                        </span>
                    </> : null}
                </div>

                {falseOrMisleadingInfo == null && errors.falseOrMisleadingInfo && showErrors ? (
                    <div className={`col-12 ${styles.errorContainer}`}>
                        <ErrorMsg className={"ErrorMsg_error"}
                            type={"error"}
                            description={"Please make a selection."}
                        />
                    </div>
                ) : null}

                {falseOrMisleadingInfo && errors.falseOrMisleadingInfoComment && showErrors ? (
                        <div className={`col-12 ${styles.errorContainer}`}>
                        <ErrorMsg className={"ErrorMsg_error"}
                            type={"error"}
                            description={"Further details is required."}
                        />
                        </div>
                    ) : null}
            </div>
            <div className={'row'}>
                <div className={'col-12'}>
                    <p className={styles.radioOptionsHeading}>
                        been convicted of any fraud or dishonesty offences?
                    </p>
                    <RadioSelector
                        options={radioOptionsYesNo}
                        onSelectionChange={(selectedValue) => {
                            setFraudOrDishonesty(selectedValue);
                        }}
                        initialValue={fraudOrDishonesty}
                    />
                    {fraudOrDishonesty && fraudOrDishonesty === 'yes' ?
                    <>
                        <label htmlFor={"setFraudOrDishonestyComment"}>If your answer is Yes, provide full details below. </label>
                        <textarea maxLength={1000}
                        value={fraudOrDishonestyComment}
                        onChange={obj => {
                            setFraudOrDishonestyComment(obj.target.value);
                        }}
                        rows={5}
                        cols={5}
                        />
                        <span className={styles.labelMaxChar}>
                            You have {fraudOrDishonestyComment ? 1000 - fraudOrDishonestyComment.length : 1000} characters left.
                        </span>
                    </> : null}
                </div>

                {fraudOrDishonesty == null && errors.fraudOrDishonesty && showErrors ? (
                    <div className={`col-12 ${styles.errorContainer}`}>
                        <ErrorMsg className={"ErrorMsg_error"}
                            type={"error"}
                            description={"Please make a selection."}
                        />
                    </div>
                ) : null}

                {fraudOrDishonesty && errors.fraudOrDishonestyComment && showErrors ? (
                        <div className={`col-12 ${styles.errorContainer}`}>
                        <ErrorMsg className={"ErrorMsg_error"}
                            type={"error"}
                            description={"Further details is required."}
                        />
                        </div>
                    ) : null}
            </div>
            <div className={'row'}>
                <div className={'col-12'}>
                    <p className={styles.radioOptionsHeading}>
                        the technical competencies to undertake the activities for which you are applying?
                    </p>
                    <RadioSelector
                        options={radioOptionsYesNo}
                        onSelectionChange={(selectedValue) => {
                            setTechnicalCompetencies(selectedValue);
                        }}
                        initialValue={technicalCompetencies}
                    />
                </div>

                {technicalCompetencies == null && errors.technicalCompetencies && showErrors ? (
                    <div className={`col-12 ${styles.errorContainer}`}>
                        <ErrorMsg className={"ErrorMsg_error"}
                            type={"error"}
                            description={"Please make a selection."}
                        />
                    </div>
                ) : null}
                
            </div>
            <br/><br/>
            <div className={"row"}>
                <div className={"col-12"}>
                <div className={styles.content}>
                    <h2>
                    Declaration by applicant
                    </h2>
                    <p>
                        I, the applicant, applying for this Import/Export Licence, a class of biodiversity conservation licence under Part 2 of the <i>Biodiversity Conservation Act 2016</i>, 
                        acknowledge that it is an offence under the <i>Biodiversity Conservation Act 2016</i> to provide false or misleading information in, or in connection with this 
                        application and I state the information I have provided is true and correct. 
                        By clicking the “I agree” button below, I also acknowledge I will be required to comply with conditions of my Licence and any other statutory obligations. 
                    </p>
                    <p>
                        <h3>Information provided in licence applications</h3>
                        It is an offence under the <i>Biodiversity Conservation Act 2016</i> to provide false or misleading information in, or in connection with a licence application.   
                    </p>
                    <p>
                        <h3>Licence conditions</h3>
                        All licences are issued with strict conditions. Itis an offence under the <i>Biodiversity Conservation Act 2016</i> to contravene a condition of a licence. 
                        The licensee and any associated organisation on the licence must have read and understood all licence <a target='_blank' href='https://www.environment.nsw.gov.au/licences-and-permits/wildlife-licences/trading-in-native-animals/licences-transport-native-animals-interstate-licences-and-permits#comply-with-licence-conditions'>conditions</a>
                         before undertaking activities authorised by this licence. before undertaking activities authorised by this licence.
                    </p>
                    <p>
                        <h3>Prior compliance matters </h3>
                        If the licensee or associated organisation on the licence has been investigated or convicted of an offence in the last 10 years in relation to any law 
                        concerning the protection, conservation or management of native species or ecological communities, or had a biodiversity conservation licence or similar 
                        permit suspended or cancelled, details must be provided with the application as an attachment.  
                    </p>
                    <p>
                        <h3>Other statutory requirements</h3>
                        The licensee or associated organisation must ensure the interstate party has acted in accordance with other interstate statutory or regulatory provisions 
                        relevant to this licence. 
                    </p>
                    <p>
                        <h3>Privacy statement</h3>
                        This application form requests information that identifies you and is defined as ‘personal information’ under the NSW <i>Privacy and Personal Information Act 1998</i>. 
                        Information supplied on this form will be used by delegated officers of the Department of Planning, Industry and Environment to assess your application and will be 
                        entered into a computer system for granting licences. You may access and amend your personal information at any time by contacting the Department.  
                    </p>
                    <p>
                        <h3>Public register</h3>
                        As required by the <i>Biodiversity Conservation Act 2016</i>, a public register of biodiversity conservation licences is published on the Department website. 
                        The public register does not include personal information of individuals (e.g. name, postal and email address, phone number and date of birth), but does 
                        include the postcode of the licensee.  
                    </p>                                                  
                </div>
                <div className={styles.agreeCheckbox}>
                    <CheckboxSelector
                    onSelectionChange={v => {
                        setAgreeDeclaration(v);
                    }}
                    initialValue={agreeDeclaration}
                    options={checkboxValues}
                    />
                </div>
                </div>
            </div>
            </div>
            <div className={`row `+ styles.topMargin128}>
            <div className={`col-12`}>
                <Button
                    disabled={agreeDeclaration != 1}
                    
                    onClick={() => {
                        if (validate(validators, setErrors)) {
                            setShowErrors(false);
                            storeData(true);
                            continueButtonHandler();
                            // dispatch(
                            //   saveImportExportApplication("", () => {
                            //     props.history.push(`./individual-fee-breakdown`);
                            //   })
                            // );
                          } else {
                            setShowErrors(true);
                            scrollToError();
                          }                       
                    }}
                >
                Continue
                </Button>
                <Button
                secondary
                onClick={() => {
                    storeData();
                    saveApplication();
                }}
            >
                Save & exit section
            </Button>
            </div>
            </div>
        </div>      

    )
}